'use client';
import './style.sass';

import React from 'react';
import {
    listPageResults,
    listPath,
    listResults,
    listSolutions,
    listSolutionsAnaliz,
    listSolutionsDifficulties,
    listSolutionsMedia,
    listSolutionsMediaParagraf,
    listSolutionsPages,
    listSolutionsParagraf,
    listStages,
    listTitle,
} from '../sk10/constans';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import TitleCase from '../../case-components/title-case';
import Target from '../reusable-components/layouts-component__sk10/target';
import LayoutPage from '../reusable-components/layouts-component__sk10/layout-page';
import Solution from '../reusable-components/layouts-component__sk10/solution';
import Media from '../reusable-components/layouts-component__sk10/media';
import Testing from '../reusable-components/layouts-component__sk10/testing';
import Results from '../reusable-components/layouts-component__sk10/results';
import Team from '../reusable-components/layouts-component__sk10/team';
const Sk10 = () => {
    const casePathname = '/cases/marketing/sk10';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section>
            <TitleCase
                img="/images/pic/ck10/ck10.png"
                listPath={listPath}
                listTitle={listTitle}
                caseName="ck10"
            />
            <Target />
            <LayoutPage listStages={listStages} />
            <Solution
                list={listSolutions}
                listAudit={listResults}
                listMedia={listSolutionsMedia}
                listMediaParagraph={listSolutionsMediaParagraf}
                listParagraph={listSolutionsParagraf}
                listPage={listSolutionsPages}
                listAnalyse={listSolutionsAnaliz}
                listDifficulties={listSolutionsDifficulties}
            />
            <Media />
            <Testing />
            <Results list={listPageResults} />
            <Team />
            {adjacentCase && (
                <NextProject
                    NextProject={{
                        nextProjectTitle: adjacentCase.case.title,
                        nextProjectImg: adjacentCase.case.image,
                        nextProjectLink: adjacentCase.case.router,
                        nextProjectText: adjacentCase.case.description,
                        nextProjectLabel: adjacentCase.label,
                    }}
                />
            )}
        </section>
    );
};

export default Sk10;
